export default {
  apiKey: '5ba1711fe435b5849d7327ba7fad2026',
  // Component to be used in the ErrorBoundary code when there's an error.
  // Could be changed to use an actual React component.
  fallbackComponent: null,
  ignoreReports: false, // Set to true to avoid sending errors to bugsnag.
  collectUserIp: false
}



// WEBPACK FOOTER //
// ./src/config/bugsnag.js